import { Button } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { logout } from '../features/auth/authSlice';
import { useNavigate } from 'react-router-dom';
import { ShowIfLoggedIn } from '../features/auth/auth_utils';

function LogoutButton() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate('/login');
  };

  return (
    <ShowIfLoggedIn>
      <Button variant="outline-primary" onClick={handleLogout}>
        Sign Out
      </Button>
    </ShowIfLoggedIn>
  );
}

export default LogoutButton;
